import Echart from "echarts-for-react"
import { useMemo } from "react"
import { usageChartBundle } from "../usage-const"

const UsageDayChart = ({ labels = [], series = [], unit, lang }) => {
  const option = useMemo(() => {
    if (!labels.length || !series.length) {
      return null
    }

    return {
      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          let result = `<div style="font-weight:bold;margin-bottom:4px;">${params[0].name}${usageChartBundle.time[lang]}</div>`

          params.forEach((item) => {
            const color = item.borderColor || item.color
            const value = Number(item.value || 0).toLocaleString()

            result += `
              <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">
                <span style="display:flex;align-items:center;">
                  <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>
                  ${usageChartBundle.info[item.seriesName]?.[lang] ?? item.seriesName}
                </span>
                <span style="font-weight:bold;">${value} ${unit}</span>
              </div>
            `
          })

          return result
        }
      },
      legend: { top: 0 },
      grid: { left: "5%", right: "2%", bottom: 40, top: 35, containLabel: true },
      xAxis: {
        type: "category",
        data: labels.map((label) => `${label.slice(-2)}${usageChartBundle.time[lang]}`),
        boundaryGap: false
      },
      yAxis: { type: "value" },
      series: series.map((item) => ({
        name: usageChartBundle.info[item.name][lang],
        type: "line",
        data: item.data,
        smooth: true,
        showSymbol: false,
        symbol: "circle",
        itemStyle: { color: "#fff", borderColor: item.color, borderWidth: 2 },
        lineStyle: { width: 2, color: item.color },
        areaStyle: item.name === "leakAmount" ? { color: item.color, opacity: 0.08 } : null
      }))
    }
  }, [labels, lang, series, unit])

  if (!option) return null

  return <Echart notMerge className="h-full w-full" option={option} />
}

export default UsageDayChart
